import { ServerMarketplaceType } from '@yoop/server-model/marketplace';

/**
 * Predicate for requested marketplaces
 * @param marketplace
 */
export const requested = (marketplace: { type?: ServerMarketplaceType }): boolean =>
  marketplace?.type === ServerMarketplaceType.DRAW ||
  marketplace?.type === ServerMarketplaceType.AUCTION;
